import styled from 'styled-components'
import {
  COLOR,
  Z_INDEXS,
} from '../../themes'
const div = 60
const img = 24
const position = (div - img) / 2
export const BUTTON = styled.div`
    z-index: ${Z_INDEXS.LV_4};
    width: ${div}px;
    height: ${div}px;
    position: fixed;
    box-shadow: 0px 4px 6px 2px ${COLOR.GRAY_5};
    right: 34px;
    bottom: 34px;
    border-radius: 50%;
    cursor: pointer;

    @media screen and (min-width: 1920px) and (min-height: 1080px) {
      position: absolute;
    }

    @media screen and (min-width: 1920px) {
      position: absolute;
    }

    @media screen and (min-height: 1080px)  {
      position: absolute;
    }

    .image-add{
      width: ${img}px;
      height: ${img}px;
      margin-top: ${position}px;
      margin-left: ${position}px;
    }
`
